
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 5.468a1 1 0 00-.767-.972L9.617 3.388A.5.5 0 009 3.874v14.658a1 1 0 00.767.972l4.616 1.108a.5.5 0 00.617-.486V5.468zM17.695 4.378A1 1 0 0017 5.33v14.665a.5.5 0 00.652.476l2.262-.724A3 3 0 0022 16.89V5.74a2 2 0 00-2.61-1.905l-1.695.543zM4.086 4.253l2.262-.724A.5.5 0 017 4.005V18.67a1 1 0 01-.695.952l-1.695.543A2 2 0 012 18.26V7.11a3 3 0 012.086-2.857z"}})])
          )
        }
      }
    